import { provideRouter, Routes } from '@angular/router';
import { LoginComponent } from './auth/components/login/login.component';
import { isLoggedGuard } from './middlewares/is.logged.guard';
import { isNotLoggedGuard } from './middlewares/is.not.logged.guard';
import { hasRoleGuard } from './middlewares/has-role.guard';
import { SecurityExpressions } from './shared/utils/security-expressions';
import { AccessDeniedComponent } from './shared/components/access-denied/access-denied.component';
import { RoleRedirectComponent } from './shared/components/role-redirect/role-redirect.component';

const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
    pathMatch: 'full',
    canActivate: [isNotLoggedGuard],
  },
  {
    path: 'dashboard',
    component: RoleRedirectComponent,
    canActivate: [isLoggedGuard]
  },
  {
    path: 'agencias',
    loadChildren: () => import('./mas-seguros/dealers/dealers.module').then(m => m.DealersModule),
    canActivate: [hasRoleGuard],
    data: { roles: SecurityExpressions.SITRACK_ATC_AND_MAS_SEGUROS }
  },
  {
    path: 'clientes',
    loadChildren: () => import('./mas-seguros/customers/customers.module').then(m => m.CustomersModule),
    canActivate: [hasRoleGuard],
    data: { roles: SecurityExpressions.SITRACK_ATC_AND_MAS_SEGUROS }
  },
  {
    path: 'tecnicos',
    loadChildren: () => import('./mas-seguros/technicians/technicians.module').then(m => m.TechniciansModule),
    canActivate: [hasRoleGuard],
    data: { roles: SecurityExpressions.SITRACK_ATC_AND_MAS_SEGUROS }
  },
  {
    path: 'solicitudes',
    loadChildren: () => import('./mas-seguros/tickets/tickets.module').then(m => m.TicketsModule),
    canActivate: [hasRoleGuard],
    data: { roles: SecurityExpressions.SITRACK_ATC_AND_MAS_SEGUROS }
  },
  {
    path: 'vehiculos',
    loadChildren: () => import('./mas-seguros/vehicles/vehicles.module').then(m => m.VehiclesModule),
    canActivate: [hasRoleGuard],
    data: { roles: SecurityExpressions.SITRACK_ATC_AND_MAS_SEGUROS }
  },
  {
    path: 'arcelor-mittal',
    loadChildren: () => import('./arcelor-mittal/arcelor-mittal.routes').then(m => m.arcelorMittalRoutes),
    canActivate: [hasRoleGuard],
    data: { roles: SecurityExpressions.SITRACK_TECHNICAL_SUPPORT_AND_ALL_AM }
  },
  {
    path: 'access-denied',
    component: AccessDeniedComponent,
    canActivate: [isLoggedGuard]
  },
  {
    path: '**',
    redirectTo: 'dashboard'
  }
];

export const routing = provideRouter(routes);